var _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcVisitPoint = function SvgIcVisitPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#0760FB",
    stroke: "#fff",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "30%",
    fill: "#fff",
    dy: ".3em",
    fontFamily: "Roboto",
    fontWeight: 600,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "50%",
    dy: ".65em"
  }, "10"))));
};
export default SvgIcVisitPoint;